// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"c608ec3e","238":"7b7a737f","338":"2847b61b","453":"ff99d102"}[chunkId] + ".chunk.js";
};